<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.organization"
              label="企业名称"
              single
              :messages="message"
              :error="!!error.organizationErrors.length"
              :error-messages="error.organizationErrors"
              :options="organizations.map(x=>x.name)"
              searchable
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.positionTag"
              label="职位类型"
              :messages="message"
              :error="!!error.positionTagsErrors.length"
              :error-messages="error.positionTagsErrors"
              :options="positionTags.map(x=>x.name)"
              searchable
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.question"
              label="练习题题目"
              type="textarea"
              removable
              rows="10"
              :messages="message"
              :error="!!error.questionErrors.length"
              :error-messages="error.questionErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <vue-trix
              v-model="insertData.answer"
              placeholder="练习题答案"
              :config="captionConfig"
              @trix-attachment-add="handleAttachmentChanges"
            ></vue-trix>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              v-model="insertData.status"
              label="发布状态"
              single
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
              :options="statusOptions"
            />
          </div>
        </div>

        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject } from '@/utils/common'
import uploadApi from '../../api/upload'
import organizationApi from '../../api/organization'
import practiceQuestionApi from '../../api/interview/practiceQuestion'
import { STATUS_OPTIONS, INTERVIEW_TAG_TYPE } from '@/utils/constants'
import positionTagApi from '@/api/interview/positionTag'

export default {
  data () {
    return {
      insertData: {
        id: null,
        question: '',
        answer: '',
        sortNum: 1,
        createdAt: '',
        positionTagId: null,
        positionTag: '',
        organization: '',
        organizationId: null,
        status: '草稿中',
      },
      message: ['Required field'],
      error: {
        questionErrors: [],
        sortNumErrors: [],
        positionTagsErrors: [],
        statusErrors: [],
        organizationErrors: [],
      },
      showId: false,
      title: '创建练习题',
      submitButtonStatus: true,
      statusOptions: STATUS_OPTIONS.map(x => x.TEXT),
      organizations: [],
      positionTags: [],
      captionConfig: {
        attachments: {
          preview: {
            caption: {
              name: false,
              size: false,
            },
          },
        },
      },
    }
  },
  created () {
    this.listPositionTag()
    this.listOrganization()
  },
  computed: {
    formReady () {
      return !this.error.questionErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.organizationErrors.length &&
          !this.error.positionTagsErrors.length &&
          !this.error.statusErrors.length
    },
    flipOrganization () {
      const flipTags = {}
      this.organizations.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipPositionTags () {
      const flipTags = {}
      this.positionTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
  },
  methods: {
    getPracticeQuestion () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.title = '编辑练习题'
        // 通过id获取详情
        practiceQuestionApi.getPracticeQuestion(params.id).then(response => {
          copyObject(response.practiceQuestion, this.insertData)
          STATUS_OPTIONS.forEach(x => {
            if (x.CODE === response.practiceQuestion.status) {
              this.insertData.status = x.TEXT
            }
          })
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listPositionTag () {
      const params = {
        type: INTERVIEW_TAG_TYPE.POSITION_TAG.CODE,
      }
      positionTagApi.listPositionTag(params).then(response => {
        this.positionTags = response.tags
        this.getPracticeQuestion()
      }).catch(error => this.showToast('获取职位失败: ' + error.msg, {
        duration: 1000,
        icon: 'fa-check',
        position: 'top-center',
        fullWidth: false,
      }))
    },
    listOrganization () {
      const params = {
        pageNumer: 1,
        pageSize: 10000,
      }
      organizationApi.listOrganization(params).then(response => {
        this.organizations = response.organizations
      }).catch(error => alert(error.msg))
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        question: this.insertData.question,
        answer: this.insertData.answer,
        organizationId: null,
        status: null,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      data.positionTagId = this.flipPositionTags[this.insertData.positionTag]
      data.organizationId = this.flipOrganization[this.insertData.organization]
      STATUS_OPTIONS.forEach(x => {
        if (x.TEXT === this.insertData.status) {
          data.status = x.CODE
        }
      })

      if (this.insertData.id != null) {
        data.id = this.insertData.id
        practiceQuestionApi.updatePracticeQuestion(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('练习题更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPracticeQuestion' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        practiceQuestionApi.savePracticeQuestion(data).then(response => {
          if (response.success === true) {
            this.showToast('添加练习题成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listPracticeQuestion' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.questionErrors = this.insertData.question ? [] : ['question is required']
      this.error.organizationErrors = this.insertData.organization ? [] : ['organization is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.positionTagsErrors = this.insertData.positionTag ? [] : ['positionTag is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    handleAttachmentChanges (event) {
      const file = event.attachment.file
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', file)
      uploadApi.uploadImage(formData).then(response => {
        event.attachment.setAttributes({ url: response.url })
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        console.log(error)
      })
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
